import { render } from "./GangList.vue?vue&type=template&id=31d7c1e4&scoped=true"
import script from "./GangList.vue?vue&type=script&lang=js"
export * from "./GangList.vue?vue&type=script&lang=js"

import "./GangList.vue?vue&type=style&index=0&id=31d7c1e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d7c1e4"]])

export default __exports__